import React from "react";
import PropTypes from "prop-types";
import { Field } from "react-final-form";
import PhoneInput from "react-phone-number-input/input";

import { composeValidators } from "./Validation";

const phoneNumberMinLength = (value) => {
  const number = value.replace(/[^0-9.]+/g, "");
  return number.length < 10
    ? "Your Phone Number should have at least 10 digits"
    : undefined;
};

const PhoneNumberField = ({ name, validate, className, ...rest }) => (
  <Field
    name={name}
    validate={composeValidators(validate, phoneNumberMinLength)}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...rest}
  >
    {({ input }) => (
      <PhoneInput
        country="US"
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...input}
        className={className}
        value={input.value || ""}
      />
    )}
  </Field>
);

PhoneNumberField.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  validate: PropTypes.func,
};

PhoneNumberField.defaultProps = {
  validate: () => undefined,
  className: "",
};

export default PhoneNumberField;
